import { uniq as _uniq } from 'lodash';

const _getTaskImages = (layers: any): any => {
  const images: any[] = [];

  for (let i = 0; i < layers.length; i++) {
    const layer = layers[i];

    const fillsProperty = layer.properties.find(
      (property: any) => property.key === 'fills',
    );

    if (fillsProperty && fillsProperty.value.length) {
      const imagesHashes = fillsProperty.value
        .filter((fillProperty: any) => fillProperty.type === 'IMAGE')
        .map((fillProperty: any) => fillProperty.imageHash);

      images.push(...imagesHashes);
    }

    if (layer.children && layer.children.length) {
      images.push(..._getTaskImages(layer.children));
    }
  }

  return images;
};

export const getTaskMaterials = ({
  fileImages,
  taskLayers,
}: {
  fileImages: any;
  taskLayers: any;
}) => {
  const taskImages = _uniq(_getTaskImages(taskLayers));

  return fileImages.filter((fileImage: any) =>
    taskImages.some((taskImage: any) => taskImage === fileImage.imageRef),
  );
};
